import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/operacao/dashboard';

export default {
    buscarEmpresas() {
        return http.get({
            url: baseRoute + '/empresas',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoEmpresas')
        });
    },

    buscarIndicadores(body) {
        return http.post({
            url: baseRoute + '/indicadores',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoIndicadores')
        });
    },

    buscarGraficoRestricoes(body) {
        return http.post({
            url: baseRoute + '/grafico',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeRestricao')
        });
    },

    buscarTotalizadores(body) {
        return http.post({
            url: baseRoute + '/totalizadores',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTotalizadores')
        });
    },

    buscarGraficoTotalizadores(body) {
        return http.post({
            url: baseRoute + '/grafico-totalizadores',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTotalizadores')
        });
    },

    buscarTabelaTotalizadores(body) {
        return http.post({
            url: baseRoute + '/tabela-totalizadores',
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoTotalizadores')
        });
    }
};
